import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';

const initialState = {
  companyData: {
    pageData: {},
    companyContacts: [],
  },
};

// Reducer function.
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMPANY_DATA:
      return updateObject(state, {
        companyData: updateObject(state.companyData, action.data),
      });
    default:
      return state;
  }
};

export default reducer;
